import Store from '@/store/computed/storeHelpers'
export default {
  computed: {
    defaultHeaders: Store.getSet({ store: 'shared', prop: 'batchAllocationLineDefaultHeaders' })
  },
  data() {
    return {
      allPossibleHeaders: [
        {
          text: "ID",
          align: "left",
          value: "id",
          type: "text"
        },
        {
          text: 'Start Time',
          value: 'startTime',
          align: "left",
          type: "time"
        },
        {
          text: "Tip",
          align: "left",
          value: "tip.name",
          type: "text"
        },
        {
          text: "Spoil",
          align: "left",
          value: "spoil.name",
          type: "text"
        },
        {
          text: "Sub-Contractor",
          align: "left",
          value: "vehicle.contractor.name",
          type: "text"
        },
        {
          text: "Vehicle",
          align: "left",
          value: "vehicle.name",
          type: "text"
        },
        {
          text: "Vehicle Type",
          align: "left",
          value: "vehicle.vehicleType.name",
          type: "text"
        },
        {
          text: "Driver",
          align: "left",
          value: "driver.name",
          type: "text"
        },
        {
          text: 'Notes',
          value: 'notes',
          align: 'left',
          type: 'text'
        },
        {
          text: 'Duplicate IDs',
          value: 'duplicateLines',
          align: 'left',
          type: 'array'
        },
        {
          text: 'AllocationID',
          value: 'allocationId',
          align: 'left',
          type: 'text'
        }
      ],
    }
  }
}